// extracted by mini-css-extract-plugin
export default {"popup":"notification_popup__CVxlt","notificationWrap":"notification_notificationWrap__ko2kG","counterNotification":"notification_counterNotification__4NbTE"};